<div class="container transaction">
  <div class="columns">
    <div class="column col-md-6 col-sm-12">
      <dl>
        <dt>{{ 'online-payment.transaction.amount' | translate }}</dt>
        <dd>{{transaction.value | number:'1.1-2'}} {{ this.transaction.currency ? this.transaction.currency : '€' }}</dd>
      </dl>
    </div>
    <div class="column col-md-6 col-sm-12">
      <form *ngIf="eTransactionQuestion" #billPaymentForm [action]="eTransactionQuestion.url" NAME="PAYBOX" method="POST">
        <input type="hidden" name="PBX_SITE" id="PBX_SITE" value="{{eTransactionQuestion.pbX_SITE}}">
        <input type="hidden" name="PBX_RANG" id="PBX_RANG" value="{{eTransactionQuestion.pbX_RANG}}">
        <input type="hidden" name="PBX_IDENTIFIANT" id="PBX_IDENTIFIANT" value="{{eTransactionQuestion.pbX_IDENTIFIANT}}">
        <input type="hidden" name="PBX_TOTAL" id="PBX_TOTAL" value="{{eTransactionQuestion.pbX_TOTAL}}">
        <input type="hidden" name="PBX_DEVISE" id="PBX_DEVISE" value="{{eTransactionQuestion.pbX_DEVISE}}">
        <input type="hidden" name="PBX_CMD" id="PBX_CMD" value="{{eTransactionQuestion.pbX_CMD}}">
        <input type="hidden" name="PBX_PORTEUR" id="PBX_PORTEUR" value="{{eTransactionQuestion.pbX_PORTEUR}}">
        <input type="hidden" name="PBX_REPONDRE_A" id="PBX_REPONDRE_A" value="{{eTransactionQuestion.pbX_REPONDRE_A}}">
        <input type="hidden" name="PBX_RETOUR" id="PBX_RETOUR" value="{{eTransactionQuestion.pbX_RETOUR}}">
        <input type="hidden" name="PBX_EFFECTUE" id="PBX_EFFECTUE" value="{{eTransactionQuestion.pbX_EFFECTUE}}">
        <input type="hidden" name="PBX_ANNULE" id="PBX_ANNULE" value="{{eTransactionQuestion.pbX_ANNULE}}">
        <input type="hidden" name="PBX_REFUSE" id="PBX_REFUSE" value="{{eTransactionQuestion.pbX_REFUSE}}">
        <input type="hidden" name="PBX_HASH" id="PBX_HASH" value="{{eTransactionQuestion.pbX_HASH}}">
        <input type="hidden" name="PBX_TIME" id="PBX_TIME" value="{{eTransactionQuestion.pbX_TIME}}">
        <input type="hidden" name="PBX_SHOPPINGCART" id="PBX_SHOPPINGCART" value="{{eTransactionQuestion.pbX_SHOPPINGCART}}">
        <input type="hidden" name="PBX_BILLING" id="PBX_BILLING" value="{{eTransactionQuestion.pbX_BILLING}}">
        <input type="hidden" name="PBX_HMAC" id="PBX_HMAC" value="{{eTransactionQuestion.pbX_HMAC}}">

        <div class="row">
          <button *ngIf="backendCallButton" type="button" class="btn btn-success backendCallButton"
                  [ngClass]="{'btn-mobile': isMobile}" (click)="validateTransaction()" [disabled]="!isValid()">
            <i class="fas fa-check"></i>
            {{ 'online-payment.payButton' | translate }}
          </button>
          <button *ngIf="!backendCallButton" type="submit" class="btn btn-success backendCallButton"
                  [ngClass]="{'btn-mobile': isMobile}">
            <i class="fas fa-check"></i>
            {{ 'online-payment.payButton' | translate }}
          </button>
        </div>
        <div class="row">
          <button type="button" class="btn btn-error payementCancelledButton"
                  [ngClass]="{'btn-mobile': isMobile}" (click)="cancelPayment()">
            <i class="fas fa-times"></i>
            {{ 'online-payment.cancelButton' | translate }}
          </button>
        </div>
        <div class="row">
          <button type="button" class="btn btn-primary paymentInfoButton" [ngClass]="{'btn-mobile': isMobile}"
                  (click)="togglePayInformation()">
            <i class="fas fa-info-circle"></i>
            {{ 'online-payment.payInformationButton' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
